import { useContext } from 'react';
import {SamarthDashboardContext} from '../samarth-dashboard-context';

export function useSamarthDashboardContext() {
    const context = useContext(SamarthDashboardContext);
    if (context === undefined) {
      throw new Error('useSamarthDashboardContext must be used within an SamarthDashboardProvider');
    }
    return context;
  }

  export function useSamarthDashboardDispatch() {
    const { dispatch } = useSamarthDashboardContext();
    return dispatch;
  }
  
  export function useSamarthDashboardSelector(selector) {
    const { state } = useSamarthDashboardContext();
    return selector(state);
  }